<template lang="html">
<v-container grid-list-xl>

<!-- <span class="display-1 text-align-center">  </span> -->
<v-layout align-center justify-center> <span class="display-3 text-align-center">Concept Dashboard</span> </v-layout>


  <v-layout align-center justify-center>


    <v-flex xs12 md4 lg8>
      <v-hover>
 

  <v-card
    class="mx-auto"  
    max-width="800"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        card_giftcard
      </v-icon>
      <span class="title font-weight-light">{{ solutionConceptDetailToBeDisplayed.firstprefsolutionconcept}} (Primary Solution Offering)</span>
    </v-card-title>

    <v-card-text class="headline font-weight-normal">
      <!-- <span> A Solution which keeps track of Tasks to be done and manages it through the "Getting things done" (GTD) method. </span>   -->
      {{ solutionConceptDetailToBeDisplayed.firstprefvalueproposition }}
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn flat :href="solutionConceptDetailToBeDisplayed.linktolfwireframe" target="_blank" color="primary" class="mx-2 mt-3">View Wireframe</v-btn> 
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>

  </v-layout>


<span class="headline"> Studying the customer and the problem space </span> <br/>


<v-layout>

<v-flex xs12 md4>
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        face
      </v-icon>
      <span class="title font-weight-light">Who are our customers?</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <!-- <span>Urban dwellers who are employed and aged betwen 18 to 34 years.
       Solution is aimed at the consumer market segment. </span> -->
       <span>Urban dwellers who are employed and aged <b>{{ solutionConceptDetailToBeDisplayed.targetagerange }} </b>.
       Solution is aimed at <b>{{solutionConceptDetailToBeDisplayed.problemdomain}}</b> market segment(s). </span>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn flat :href="solutionConceptDetailToBeDisplayed.userpersonalink" target="_blank" color="primary" class="mx-2 mt-3">View Persona</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>


    <v-flex xs12 md4>
      <v-hover>
    <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        person_pin
      </v-icon>
      <span class="title font-weight-light">Customer Pain Point (Primary)</span>
    </v-card-title>

    <v-card-text class="headline font-weight-normal">
      <!-- "There are too many tasks for me to handle. I find it hard to prioritise them and be productive while at it." -->
      {{ solutionConceptDetailToBeDisplayed.customerproblemdescription }}
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/addpainpoints" target="_blank" flat color="primary">Explore other pain points</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>


  
     <v-flex xs12 md4 >
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        supervisor_account
      </v-icon>
      <span class="title font-weight-light">Needs of our user(s)</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      "As a <b>casual user</b>, I want <b>to add a task in the least amount of steps possible</b> so that I can collect all tasks to be managed in a single location"
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/addstoriespainpoints" target="_blank" flat color="primary">View other User Stories</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>



  </v-layout>



<!-- //New Row -->

<span class="headline"> Our Solution </span>

  <v-layout>

<v-flex xs12 md4>
      <v-hover>
   <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        leak_add
      </v-icon>
      <span class="title font-weight-light">What we learnt from our competition</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <span></span>
        <ul class="headline font-weight-light">
         Our competitor <b>{{competingproducts.productnametext}}</b>, offers features such as {{competingproducts.productlistoffeaturestext}} 
          <!-- <li><b>Calendar Synk</b> - Syncs ToDos with a calendar and allows for meetings scheduling and meeting notes.</li> -->
          <!-- <li><b>Contact notes</b> - Ties ToDo list data with each contact involved in the task.</li> -->
        </ul>
      
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/dumcurrentmarketplayers" target="_blank" flat color="primary">Review other competitors</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>



<v-flex xs12 md4>
      <v-hover>
   <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        assignment_returned
      </v-icon>
      <span class="title font-weight-light">List of planned features (for the solution)</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <span></span>
        <ul class="headline font-weight-light">
         For the initial release, we plan to include the following features: <b> Export tasks to csv </b>, <b> Filter based on priority </b>
          <!-- <li><b>Calendar Synk</b> - Syncs ToDos with a calendar and allows for meetings scheduling and meeting notes.</li> -->
          <!-- <li><b>Contact notes</b> - Ties ToDo list data with each contact involved in the task.</li> -->
        </ul>
      
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/addproductfeatures" target="_blank" flat color="primary">View all features</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>



 <v-flex xs12 md4 >
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        attach_money
      </v-icon>
      <span class="title font-weight-light">How we make money</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      We plan to monetize this innovation via <b>advertising</b>. This strategy will be integrated into the early desings of the solution.
    </v-card-text>

    <!-- <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/bifdashboard" flat color="primary">Review strategy</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions> -->
  </v-card>
        </v-hover>
    </v-flex>
   

  </v-layout>




<!-- //New Row -->

<span class="headline"> When the customers interacted with our solution </span>


<v-layout>


<v-flex xs12 md4 >
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        assignment_turned_in
      </v-icon>
      <span class="title font-weight-light">The customer problem is resolved..</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      When task management and personal planning is done through a streamlined system and <b>task completion rate per month improves by 20%</b>.
    </v-card-text>

    <!-- <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/addstoriespainpoints" flat color="primary">View other User Stories</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions> -->
  </v-card>
        </v-hover>
    </v-flex>



    <v-flex xs12 md4 >
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        local_shipping
      </v-icon>
      <span class="title font-weight-light">How we intend to deliver the solution</span>
    </v-card-title>

    <v-card-text class="headline font-weight-normal">
      We plan to distribute our product via: <b>The web</b>, as our primary medium.
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/adddistributionmedium" target="_blank" flat color="primary">change distribution medium</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>



   




<v-flex xs12 md4>
      <v-hover>
    <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        record_voice_over
      </v-icon>
      <span class="title font-weight-light">Customer Quotes (on using the solution prototype)</span>
    </v-card-title>

    <v-card-text class="headline font-weight-normal">
      <!-- "There are too many tasks for me to handle. I find it hard to prioritise them and be productive while at it." -->
      <span> "{{ quoteToBeDisplayed.firstprefquotetext }}"</span>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        > 
          <v-btn to="/Dumaddquotes" target="_blank" flat color="primary">View more Quotes</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex> 


</v-layout>



<!-- //New Row -->

<span class="headline"> Planning the next steps... </span>

  <v-layout>


    <v-flex xs12 md4>
      <v-hover>
 

              <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        rate_review
      </v-icon>
      <span class="title font-weight-light">Problem-Solution fit review</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      The Customer problem always keeps evolving. We need to check back for relevance of problem-solution fit. The date for the next review is : <b>{{ solutionConceptDetailToBeDisplayed.problemSolutionfitReviewDateFormatted }}</b>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/addparallelinnovations" target="_blank" flat color="primary">Reschedule</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>



  <v-flex xs12 md4>
      <v-hover>
   <v-card
    class="mx-auto"  
    max-width="400"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        next_week
      </v-icon>
      <span class="title font-weight-light">Parallel Products</span>
    </v-card-title>

    <v-card-text class="headline font-weight-light">
      <span>At present, we can think of this additional product concept which can 
        
        one of the we can think of these parallel innovations which can be of value to our customer base:</span>
        <ul class="headline font-weight-light">
          <li><b>{{parallelSolutionConceptsToBeDisplayed.solutionname}}</b> - {{parallelSolutionConceptsToBeDisplayed.solutiondescription}} </li>
          <!-- <li><b>Calendar Synk</b> - Syncs ToDos with a calendar and allows for meetings scheduling and meeting notes.</li> -->
          <!-- <li><b>Contact notes</b> - Ties ToDo list data with each contact involved in the task.</li> -->
        </ul>
      
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
          <v-btn to="/addparallelinnovations" target="_blank" flat color="primary">Review More such solutions</v-btn>
        </v-layout>
      </v-list-tile>
    </v-card-actions>
  </v-card>
        </v-hover>
    </v-flex>



  </v-layout>

  </v-container>
</template>



<script>
import db from '../fb'
//import Popup from '../components/Popup'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {
  //  Popup
  },
  data() {
    return { 
      linktolfwireframe: 'https://www.duckduckgo.com',
      doWe: false,
      projecttitle:'My Venture v22',
      projecttitleEnabled: false,
      projecttitleLabelText: 'Provide a title for your project',
      customerproblemdescription:'Description Blah Blah Blah Blah', 
      customerproblemdescriptionEnabled: false,
      customerproblemdescriptionLabelText: 'Describe the problem that the customer is facing',
      whythisproblem: 'Why Blah Blah Blah Blah',
      whythisproblemEnabled: false,
      whythisproblemLabelText: 'Why is the problem important to the customer?',
      targetagerange: 'between 18 and 60 years',
      targetagerangeEnabled: false,
      targetagerangeLabelText: 'What is the age range of the target audience?',
      problemdomain: 'Not Sure',      
      problemdomainEnabled: false,
      problemdomainLabelText: 'Which domain does this Problem fall in?',
      additionaldetailforproblem: 'Additional detail Blah Blah Blah Blah',
      additionaldetailforproblemEnabled: false,
      additionaldetailforproblemLabelText: 'Is there any other detail you would like to add?',
      dropdownList: [
        {component: 'projecttitle', isEnabled: false, titleText: 'Provide a title for your project'},
        {component: 'customerproblemdescription', isEnabled: false, titleText: 'Describe the problem that the customer is facing'},
        {component: 'whythisproblem', isEnabled: false, titleText: 'Why is the problem important to the customer?'},
        {component: 'targetagerange', isEnabled: false, titleText: 'What is the age range of the target audience?'},
        {component: 'problemdomain', isEnabled: false, titleText: 'Which domain does this Problem fall in?'},
        {component: 'additionaldetailforproblem', isEnabled: false, titleText: 'Is there any other detail you would like to add?'}
      ],
      customerproblemdetails: [
        { title: 'Add Project Title', storagecode: 'projecttitle', labeltext: 'Provide a title for your project', type: 'title', textValue: 'My Venture v2', prependicon: 'edit', componentid: true, tooltip: true },
        { title: 'Add Details of the customer problem', storagecode: 'customerproblemdescription', labeltext: 'Describe the problem that the customer is facing', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'edit', componentid: true, tooltip: true },
        { title: 'Add Importance of the problem to the customer', storagecode: 'whythisproblem', labeltext: 'Why is the problem important to the customer?', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'folder', componentid: false, tooltip: false },
        { title: 'Add Age range', storagecode: 'targetagerange', labeltext: 'What is the age range of the target audience?', type: 'agerange', prependicon: 'edit', componentid: false, tooltip: true },
        { title: 'Add the problem domain', storagecode: 'problemdomain', labeltext: 'Which domain does this Problem fall in?', type: 'select', textValue: 'Not Sure', prependicon: 'edit', componentid: false, tooltip: true },
        { title: 'Add additional misc. details', storagecode: 'additionaldetailforproblem', labeltext: 'Is there any other detail you would like to add?', type: 'text', textValue: 'Blah Blah Blah Blah', prependicon: 'edit', componentid: false, tooltip: true }
      ],
      solutionconcepts: [],
      quotes: [],
      quoteToBeDisplayed: [],
      solutionConceptDetailToBeDisplayed: [],
      parallelSolutionConceptsToBeDisplayed: [],
      competingproducts: [],
      slider: 45,
        volume: 10,
        age: [18, 60],
      items: ['Enterprise', 'Consumer', 'Both Enterprise and Consumer', 'Not Sure'],
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      snackbar: false
    }
  },
  methods: {
    submit(){
      //console.log(this.dropdownList[1].isEnabled)
      
//  if(this.$refs.form.validate()) {
//         console.log("Attempt to submit")
//         const project = {

//           projecttitle: this.projecttitle,
//           customerproblemdescription: this.customerproblemdescription,
//           whythisproblem: this.whythisproblem,
//           targetagerange: this.targetagerange,
//           problemdomain: this.problemdomain,
//           additionaldetailforproblem: this.additionaldetailforproblem
//         }

//       //   db.collection('projects').add(project).then(() => {
//       //     console.log("added to db!")
//       //   })
//       // }

//         db.collection('projects').add(project).then(function(docRef) {
//                 console.log("Document written with ID: ", docRef.id);
//             })
//             .catch(function(error) {
//                 console.error("Error adding document: ", error);
//             });
//         }

      this.$router.push('ranksolutions')

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
    
  },
  computed: {
    remainingDetailsToBeAdded(){
      return this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
    }
  },
  created(){
    
// Getting the details of the solution concept - overall
db.collection('projects').doc(this.getProjectID()).get().then(res => {

      // console.log("snapshot looks like this:");
      // console.log(red.docs);

      if (res) {
       this.solutionConceptDetailToBeDisplayed = res.data() 
        //console.log(this.solutionConceptDetailToBeDisplayed.projecttitle)
      } else {
        //console.log('No document exists')
      }


    })




 

 // Getting the first customer quote from the list of quotes provided by the customer when using the application
 db.collection("projects").doc(this.getProjectID()).collection('quotesregardingfirstprefsolutionconcept')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('quotesregardingfirstprefsolutionconcept').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.quoteToBeDisplayed = snapshot.data()
                    //console.log(this.quoteToBeDisplayed.firstprefquotetext)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })


    } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section retrieving quotes

 // Getting the first parallel solution concept from the list of such concepts  
 db.collection("projects").doc(this.getProjectID()).collection('parallelsolutionconcepts')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('parallelsolutionconcepts').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.parallelSolutionConceptsToBeDisplayed = snapshot.data()                    
                    //console.log(this.parallelSolutionConceptsToBeDisplayed.solutionname)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })

    } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section 

// Getting the first parallel solution concept from the list of such concepts  
 db.collection("projects").doc(this.getProjectID()).collection('competingproducts')
.limit(1)
.get()
.then(querySnapshot => {
    if (!querySnapshot.empty) {
        //We know there is one doc in the querySnapshot
        const queryDocumentSnapshot = querySnapshot.docs[0]; 
        //console.log(queryDocumentSnapshot.ref.id)

        let ref = db.collection("projects").doc(this.getProjectID()).collection('competingproducts').doc(queryDocumentSnapshot.ref.id)
          ref.get()
          .then(snapshot => {  //DocSnapshot
                if (snapshot.exists) {
                    this.competingproducts = snapshot.data()                    
                    //console.log(this.parallelSolutionConceptsToBeDisplayed.solutionname)
                } else {
                    // snapshot.data() will be undefined in this case
                    //console.log("No such document!");
                }  
          })

          } else {
        //console.log("No document corresponding to the query!");
        return null;
    }
});
// End of section 


//   const dbref = db.collection('projects').get().then(querySnapshot => { parallelsolutionconcepts
//   querySnapshot.forEach(documentSnapshot => {
//     console.log(`documentReference.id   = ${documentSnapshot.id}`);
//     console.log(`documentReference.path = ${documentSnapshot.ref.path}`);
//     // console.log(`documentReference.ref = ${JSON.stringify(documentSnapshot.ref)}`);
//   });
// });
    //console.log(this.solutionconcepts)

  }
};
</script>

<style>
.rounded-card{
  border-radius:20px;
}
</style>
